export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">关于51影院</h2>
          <p className="text-sm text-foreground-500">了解我们的故事与使命</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="p-6 md:p-8 rounded-lg bg-background-100 border border-background-200/40">
            <div className="flex flex-col md:flex-row items-start gap-6">
              <div className="flex-shrink-0 w-16 h-16 flex items-center justify-center rounded-xl bg-primary-500">
                <span className="font-heading text-2xl text-background-50 font-bold">51</span>
              </div>
              <div>
                <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-4">
                  51影院诞生于2024年，致力于打造最全面的免费高清影视资源聚合平台。我们深度整合<strong>奇优影院</strong>、<strong>98影院</strong>、<strong>优优色影院</strong>、<strong>cc影院</strong>和<strong>96影院</strong>等热门站点资源，通过智能聚合技术将分散在各站的影片、剧集、综艺、动漫内容统一呈现，让观众无需在多个站点间来回切换，一个入口即可畅享全网影视资源。
                </p>
                <p className="text-sm md:text-base text-foreground-400 leading-relaxed">
                  平台覆盖电影、电视剧、综艺、动漫、纪录片五大品类，拥有超过10万部影视内容，每日更新200+最新片源。从经典老片到热映新作，从国产佳作到海外精选，51影院始终坚持&ldquo;免费、高清、全面、便捷&rdquo;的服务理念，让每一位影迷都能在这里找到喜爱的内容。未来，我们将持续拓展资源站点合作，优化观影体验，打造华语地区最具影响力的影视聚合平台。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}